import React, { useState, useEffect } from "react";
import { Box, CardContent, Tab, Tabs, Typography } from "@mui/material";
import { StyledCard } from "../../assets/styled-components/StyledCard";
import CustomAgGrid from "../commoncomponents/CustomAgGrid";
import { ErrorChips, SuccessChips } from "../../assets/styled-components/chips";
import axios from "axios";
import { getAuthToken, getFacilityId } from "../../utility/tokenUtility";
import { BemsGraph, FemsGraph } from "../../utility/apiURLS";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { updateWorkOrderStatus } from "../../redux/actions/workOrderActionTypes";
import CustomSelectInput from "../commoncomponents/CustomSelectInput";
import { useAccess } from "../../AccessContext";
import utilities from "../../utility/utilities";

const WorkRequestToWorkOrder = () => {

  const accessData = useAccess();
  const accessWO = utilities.getScreenPermissions(accessData, "ENGT001");

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const serviceOptions = [
    { label: "FEMS", value: "FEMS", id: 1 },
    { label: "BEMS", value: "BEMS", id: 2 },
  ];

  const handleLinkClick = (deptid) => (event) => {
    event.preventDefault(); // Prevent default link navigation

    // Dispatch any action you need
    dispatch({ type: 'CLEAR_BASIC_DETAILS_WORK_ORDER_SUMMARY', payload: {} });
    dispatch({ type: 'CLEAR_DECRYPTDATA_HYPERLINK', payload: {} });
    dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: "", percentage: 0 }))
    const title = `Create Unscheduled Work Order`;
    const deptData = {
      ...deptid, assetno: { label: deptid.assetno, value: deptid.assetId },
      categoryId: { label: deptid.categoryName, value: deptid.categoryId },
      typeId: { label: deptid.type, value: deptid.typeId },
    }
    // Navigate with state parameters
    navigate("/workorder/register", { state: { title,isCreateMode:true,deptid: deptData } },
    );

  };

  const colDef = [
    {
      field: "deptworkrequestno",
      headerName: "Work Request No.",
      minWidth: 170,
      cellRenderer: (params) => {
        const { status } = params.data;

        if (status === "Open" && localStorage.getItem("roleName") !== "DeptUser" && accessWO?.canCreate) {
          return (
            <a
              href="/workorder/register" // Placeholder href for accessibility
              onClick={handleLinkClick(params?.data)}
              style={{ textDecoration: 'underline', color: '#1a73e8' }}
            >
              {params.value}
            </a>
          );
        }
        return params.value; // Plain text if status is not 'Open'
      },
    },
    {
      field: "requestor",
      headerName: "Requestor",
      minWidth: 170,
    },
    {
      field: "assetdesc",
      headerName: "Asset Description",
      minWidth: 300,
    },
    {
      field: "type",
      headerName: "Work Request Type",
      minWidth: 180,
    },
    {
      field: "workorderStatus",
      headerName: "Status",
      minWidth: 150,
      cellRenderer: (params) => {
        if (params.data.status === "Open") {
          return <ErrorChips label={params.data.status} />;
        } else {
          return <SuccessChips label={params.data.status} />;
        }
      },
    },
  ];



  const [rowData, setRowData] = useState([]);
  const [gridApi, setGridApi] = useState(null);
  const [isloading, setIsLoading] = useState(false)
  const facilityId = getFacilityId("");
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  const [service, setService] = useState(serviceOptions[0]);


  const handleServiceChange = (selectedService) => {
    setService(selectedService);
    fetchUserDepartments(selectedService?.label)
  };


  const fetchUserDepartments = async (selectedService) => {
    setIsLoading(true);
    try {
      const token = getAuthToken("id_token");
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      };
      const departmentid = localStorage.getItem("roleName") === "DeptUser" ? 1 : 0;
      const userid = localStorage.getItem("UserId");
      let response;
      if (selectedService === "FEMS") {
        response = await axios.get(
          `${FemsGraph}/api/GraphfemDepartmentrequest/Getfemsworkrequestlist/${facilityId}/${currentYear}/${currentMonth}/0/${userid}/${token}`,
          config
        );
      } else if (selectedService === "BEMS") {
        response = await axios.get(
          `${BemsGraph}/api/GraphbemDepartmentrequest/Getbemsworkrequestlist/${facilityId}/${currentYear}/${currentMonth}/0/${userid}/${token}`,
          config
        );
      }

      setRowData(response.data.items.filter((item) => item?.status === "Open" && item?.workorderNo ==='').slice(0, 25));

    } catch (error) {
      console.error("Error fetching data", error);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchUserDepartments(service?.label);
  }, []);

  return (
    <>
      <StyledCard>
        <CardContent>
          <Typography
            mb={1.5}
            variant="h5"
            fontWeight={700}
            color={"text.primary"}
          >
            New Work Requests ({rowData.length})
          </Typography>

          <Box mt={2}>
            <CustomSelectInput
              fullWidth={false}
              labelSize={"14px"}
              sx={{ width: 150 }}
              label={""}
              options={serviceOptions}
              value={service}
              onChange={handleServiceChange}
              placeholder={"Select Service"}
              highlight={true}
              disableClearable={true}
            />
          </Box>

          <Box mt={2}>
            {/* CustomAgGrid component with dynamic rowData based on the selected tab */}
            <CustomAgGrid
              columns={colDef}
              rows={rowData}
              gridApi={gridApi}
              isLoading={isloading}
              setGridApi={setGridApi}
              height={260}
              disableFilter={true}
              pagination={false}
            />
          </Box>
        </CardContent>
      </StyledCard>
    </>
  );
};

export default WorkRequestToWorkOrder;
